import React from "react";
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import MotorcycleIcon from '@material-ui/icons/Motorcycle';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import DirectionsBusIcon from '@material-ui/icons/DirectionsBus';

const CarTypeIcon = (props) => {

    const defaultIcon = {
        carType: "Veículo",
        icon: <AirportShuttleIcon style={{ fontSize: props.size ? props.size : 30 }} />
    }

    const icons = [
        {
            carType: "Utilitários",
            icon: <LocalShippingIcon style={{ fontSize: props.size ? props.size : 30 }} />
        },
        {
            carType: "Carro",
            icon: <AirportShuttleIcon style={{ fontSize: props.size ? props.size : 30 }} />
        },
        {
            carType: "Caminhão",
            icon: <LocalShippingIcon style={{ fontSize: props.size ? props.size : 30 }} />
        },
        {
            carType: "Moto",
            icon: <MotorcycleIcon style={{ fontSize: props.size ? props.size : 30 }} />
        },
        {
            carType: "Ônibus",
            icon: <DirectionsBusIcon style={{ fontSize: props.size ? props.size : 30 }} />
        }
    ]

    const getIcon = (type) => {
        const foundIcon = icons.filter((value) => value.carType === type)
        return foundIcon.length !== 0 ? foundIcon[0].icon : defaultIcon.icon
    };

    return (
        <div>
            {getIcon(props.type)}
        </div>
    )
}


export default CarTypeIcon